import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import BiddingsDistributionContainer from '../containers/BiddingsDistribution/BiddingsDistribution.container'
import BuyingModalitiesContainer from '../containers/BuyingModalities/BuyingModalities.container'
import BuyerSectionContainer from '../containers/BuyerSection/BuyerSection.container'
import ContractOrdersContainer from '../containers/ContractOrders/ContractOrders.container'
import FooterContainer from '../containers/Footer/Footer.container'
import ProvidersTypeContainer from '../containers/ProvidersType/ProvidersType.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import SuppliersAmountContainer from '../containers/SuppliersAmount/SuppliersAmount.container'
import SuppliersContainer from '../containers/Suppliers/Suppliers.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import TradedAmountsContainer from '../containers/TradedAmounts/TradedAmounts.container'
import TradedProductsContainer from '../containers/TradedProducts/TradedProducts.container'
import { Box } from './Buyer.styles'

/**
 * The Buyer's page.
 */
const Buyer = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.organizations} />
    <SearchBuyerPanelContainer />
    <BuyerSectionContainer>
      <Box mt={5}>
        <TradedAmountsContainer />
      </Box>
      <Box mt={8}>
        <BuyingModalitiesContainer />
      </Box>
      <Box mt={8}>
        <BiddingsDistributionContainer />
      </Box>
      <Box mt={8}>
        <ContractOrdersContainer />
      </Box>
      <Box mt={8}>
        <TradedProductsContainer />
      </Box>
      <Box mt={8}>
        <SuppliersContainer />
      </Box>
      <Box mt={8}>
        <ProvidersTypeContainer />
      </Box>
      <Box mt={8}>
        <SuppliersAmountContainer />
      </Box>
    </BuyerSectionContainer>
  </BrandLayout>
)

export default Buyer
